<template>
  <v-row class="ma-0">
    <v-col cols="12" class="pa-0">
      <v-card flat>
        <v-col cols="12" class="pa-0">
          <v-toolbar flat height="60" dark color="primary">
            <v-btn fab x-small color="white" depressed @click="onClose()">
              <v-icon class="primary--text">close</v-icon>
            </v-btn>
            <v-toolbar-title class="hidden-xs-only white--text pl-2">{{ '検索結果' + ' ... [' + search + ']' }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-col>
        <v-card-text tile :style="contentsHeight" class="pa-0" color="transparent">
          <v-row class="ma-0">
            <v-col cols="3" class="pa-0">
              <RecycleScroller
                class="scroller"
                :items="filteredItems"
                :item-size="60"
                key-field="key"
              >
                <template v-slot="{ item }">
                  <v-list>
                    <v-list-item
                      :key="item.key"
                      @click.stop="onSelect(item)"
                    >
                  <v-row align="center">
                    <v-col cols="auto" class="py-0">
                      <v-avatar size="38">
                        <img v-if="getAvatar(item)" :src='getAvatar(item)'>
                        <v-avatar v-else size="36" color="primary"><span class="font-weight-bold white--text" style="font-size:24px; user-select: none; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ getNamePrefix(item) }}</span></v-avatar>
                      </v-avatar>
                    </v-col>
                    <v-col class="py-0">
                      <v-row align="center" justify="start">
                        <v-col cols="12" class="py-0">
                          <v-row>
                            <v-col v-if="item.chatShare == 'yes' || item.chatsShare" cols="1" class="pa-0" align="center">
                              <v-icon x-small color="success" class="white--text">mdi-earth</v-icon>
                            </v-col>
                            <v-col v-if="item.chatType == 'group' && item.classroom" cols="1" class="pa-0" align="center">
                              <v-icon x-small color="primary" class="white--text">mdi-school</v-icon>
                            </v-col>
                            <v-col v-if="item.chatType == 'group'" cols="1" class="pa-0" align="center">
                              <v-icon x-small color="primary" class="white--text">mdi-chat</v-icon>
                            </v-col>
                            <v-col v-if="!item.public" cols="1" class="pa-0" align="center">
                              <v-icon x-small color="error" class="">mdi-lock</v-icon>
                            </v-col>
                            <v-col cols="auto" class="pa-0" align="start">
                              <p class="ma-0 pa-0">{{ item.name }}</p>
                            </v-col>
                            <!-- <v-col v-if="item.share" cols="auto" class="pl-0 pr-1 py-0">
                              <v-icon small color="success" class="white--text">mdi-earth</v-icon>
                            </v-col>
                            <v-col v-if="item.type == 'group' && item.classroom" cols="auto" class="pl-0 pr-1 py-0">
                              <v-icon small color="primary" class="white--text">mdi-school</v-icon>
                            </v-col>
                            <v-col v-if="item.type == 'group'" cols="auto" class="pl-0 pr-1 py-0">
                              <v-icon small color="primary" class="white--text">mdi-chat</v-icon>
                            </v-col>
                            <v-col v-if="!item.public" cols="auto" class="pl-0 pr-1 py-0">
                              <v-icon small color="error" class="">mdi-lock</v-icon>
                            </v-col> -->
                            <!-- <v-col cols="auto" class="pl-0 pr-1 py-0">
                              <p class="ma-0 hidden-sm-and-down text-left">{{ item.name }}</p>
                            </v-col> -->
                          </v-row>
                        </v-col>
                        <v-col cols="12" class="py-0">
                          <v-row justify="space-between">
                            <v-chip v-if="item.type != 'school'" x-small outlined color="primary" class="hidden-sm-and-down">
                              <span class="text-overflow-hidden">{{ getSchool(item) }}</span>
                            </v-chip>
                            <!-- <p v-if="item.type != 'school'" class="ma-0 px-0 caption hidden-sm-and-down">{{ getSchool(item) }}</p> -->
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="auto" class="py-0">
                      <v-avatar size="24" color="primary"><span class="font-weight-bold white--text" style="font-size:14px; user-select: none;">{{ filteredCounts[item.key] }}</span></v-avatar>
                    </v-col>
                  </v-row>
                    </v-list-item>
                  </v-list>
                </template>
              </RecycleScroller>
            </v-col>
            <v-col cols="9" class="pa-0">
              <template-chat-view
                :mode="'search'"
                :item="item"
                :contentsHeight="contentsHeight"
                :messages="displayMessages"
                :search="search"
                @open="onOpenItem"
                @remove="onRemoveDialog"
              >
              </template-chat-view>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <div>
      <app-loading :loading="loading"></app-loading>
    </div>
  </v-row>
</template>

<script>
import Vue from 'vue'
import * as async from 'async'
import firebase from 'firebase/app'
import 'firebase/firestore'
import { mapGetters } from 'vuex'
import TemplateChatView from './TemplateChatView.vue'
Vue.component('template-chat-view', TemplateChatView)
export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      users: 'users/users',
      publicUsers: 'publicUsers/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      chatRefStatus: 'chatRefStatus/chatRef',
      windowSize: 'shared/windowSize'
    }),
    filteredCounts () {
      var temp = {}
      for (var i in this.filteredMessages) {
        var key = this.filteredMessages[i].from
        if (this.filteredMessages[i].chatType === 'group' || this.filteredMessages[i].chatType === 'school') {
          key = this.filteredMessages[i].to
        } else {
          if (this.filteredMessages[i].to !== this.user.uid) {
            key = this.filteredMessages[i].to
          }
        }
        if (!temp[key]) {
          temp[key] = 1
        } else {
          temp[key] += 1
        }
      }
      return temp
    },
    filteredItems () {
      var temp = []
      for (var i in this.mySchools) {
        if (this.filteredCounts[this.mySchools[i].key]) {
          var s = JSON.parse(JSON.stringify(this.mySchools[i]))
          s['type'] = 'school'
          s['share'] = false
          temp.push(s)
        }
      }
      for (i in this.shareGroups) {
        if (this.filteredCounts[this.shareGroups[i].key]) {
          s = JSON.parse(JSON.stringify(this.shareGroups[i]))
          s['type'] = 'group'
          s['share'] = true
          temp.push(s)
        }
      }
      for (i in this.publicClass) {
        if (this.filteredCounts[this.publicClass[i].key]) {
          s = JSON.parse(JSON.stringify(this.publicClass[i]))
          s['type'] = 'group'
          s['share'] = false
          temp.push(s)
        }
      }
      for (i in this.localClass) {
        if (this.filteredCounts[this.localClass[i].key]) {
          s = JSON.parse(JSON.stringify(this.localClass[i]))
          s['type'] = 'group'
          s['share'] = false
          temp.push(s)
        }
      }
      for (i in this.publicGroup) {
        if (this.filteredCounts[this.publicGroup[i].key]) {
          s = JSON.parse(JSON.stringify(this.publicGroup[i]))
          s['type'] = 'group'
          s['share'] = false
          temp.push(s)
        }
      }
      for (i in this.localGroup) {
        if (this.filteredCounts[this.localGroup[i].key]) {
          s = JSON.parse(JSON.stringify(this.localGroup[i]))
          s['type'] = 'group'
          s['share'] = false
          temp.push(s)
        }
      }
      for (i in this.myUsers) {
        if (this.filteredCounts[this.myUsers[i].key]) {
          s = JSON.parse(JSON.stringify(this.myUsers[i]))
          s['type'] = 'user'
          s['share'] = false
          temp.push(s)
        }
      }
      for (i in this.myPublicUsers) {
        if (this.filteredCounts[this.myPublicUsers[i].key]) {
          s = JSON.parse(JSON.stringify(this.myPublicUsers[i]))
          s['type'] = 'user'
          s['share'] = true
          temp.push(s)
        }
      }
      return temp
    },
    displayMessages () {
      var temp = []
      if (this.selected) {
        for (var i in this.filteredMessages) {
          var key = this.filteredMessages[i].from
          if (this.filteredMessages[i].chatType === 'group' || this.filteredMessages[i].chatType === 'school') {
            key = this.filteredMessages[i].to
          } else {
            if (this.filteredMessages[i].to !== this.user.uid) {
              key = this.filteredMessages[i].to
            }
          }
          if (this.selected.key === key) {
            temp.push(this.filteredMessages[i])
          }
        }
      } else {
        temp = this.filteredMessages
      }
      return temp
    },
    filteredMessages () {
      var temp = []
      for (var i in this.messages) {
        if (this.messages[i].type === 'text' && this.messages[i].content !== null && this.messages[i].content.indexOf(this.search) !== -1) {
          temp.push(JSON.parse(JSON.stringify(this.messages[i])))
        } else if (typeof this.messages[i].note !== 'undefined' && this.messages[i].note !== null) {
          if (this.messages[i].note.indexOf(this.search) !== -1) {
            temp.push(JSON.parse(JSON.stringify(this.messages[i])))
          }
        }
      }
      temp.sort(function (a, b) {
        if (a.createdAt > b.createdAt) return 1
        if (a.createdAt < b.createdAt) return -1
        return 0
      })
      return temp
    },
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60) + 'px;'
    }
  },
  props: [ 'item', 'search', 'mySchools', 'shareGroups', 'publicClass', 'localClass', 'publicGroup', 'localGroup', 'myUsers', 'myPublicUsers' ],
  data () {
    return {
      loading: false,
      messages: [],
      selected: null
    }
  },
  created () {
    this.loading = true
  },
  mounted () {
    this.wait()
  },
  methods: {
    async wait () {
      this.loading = true
      const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
      await pause(200).then(() => {
        this.searchChatMessage()
        // this.loading = false
      })
    },
    getAvatar (item) {
      var url = null
      if (item.avatar) {
        url = item.avatar.thumbnail
      }
      return url
    },
    getSchool (item) {
      for (var key in item.schools) {
        if (item.schools[key]) {
          var index = this.schools.findIndex(school => school.key === key)
          if (index !== -1) {
            return this.schools[index].name
          }
        }
      }
      return ''
    },
    getNamePrefix (item) {
      var name = '？'
      if (item.name) {
        name = item.name.slice(0, 1)
      }
      return name
    },
    onSearchSub (chatRef) {
      var vm = this
      const db = firebase.firestore()
      return new Promise((resolve) => {
        var ref = db.collection('chats').doc(chatRef.location).collection('data').where('visible', '==', true)
        ref.get().then(function (snapshots) {
          async.eachSeries(snapshots.docs, function (chat, cb) {
            var data = JSON.parse(JSON.stringify(chat.data()))
            data['parent'] = JSON.parse(JSON.stringify(chatRef))
            vm.messages.push(data)
            cb()
          }, function (error) {
            if (error) {
              // console.log(error)
            }
            resolve()
          })
        })
      })
    },
    searchChatMessage () {
      this.messages = []
      var vm = this
      this.loading = true
      const db = firebase.firestore()
      var dbRef = db.collection('chats_refs').doc(this.user.uid).collection('refs')
      dbRef.get().then(function (snapshots) {
        async.eachSeries(snapshots.docs, function (chat, cb) {
          var ref = JSON.parse(JSON.stringify(chat.data()))
          if (ref.enable && ref.status === 'accepting') {
            vm.onSearchSub(ref).then(() => {
              cb()
            })
          } else {
            cb()
          }
        }, function (error) {
          if (error) {
            // console.log(error)
          }
          vm.loading = false
        })
      })
    },
    onSelect (item) {
      this.selected = item
    },
    onOpenItem: function (value) {
      this.$emit('open', { item: value.item })
    },
    onRemoveDialog: function (value) {
      // console.log(value)
    },
    onClose () {
      this.$emit('dismissed')
    }
  }
}
</script>

<style scoped>
p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none;
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer */
  -khtml-user-select: none; /* KHTML browsers (e.g. Konqueror) */
  -webkit-user-select: none; /* Chrome, Safari, and Opera */
  -webkit-touch-callout: none; /* Disable Android and iOS callouts*/
}
.scroller {
  height: 100%;
}

span.text {
  font-size: 14px;
  /* vertical-align: middle; */
  color: black !important;
  border-radius: 4px;
  max-width: 70% !important;
  background-color: #E1F5FE80;
  display: inline-block;
  white-space: pre-wrap;
}

span.text-r {
  font-size: 14px;
  /* vertical-align: middle; */
  color: black !important;
  border-radius: 4px;
  max-width: 70% !important;
  background-color: #FFCCBC40;
  display: inline-block;
  white-space: pre-wrap;
}
</style>
